import React from 'react';
import { Container } from 'components/common';
import { Wrapper, Flex, Details, Tel, FooterLogo, FooterText, DrText, DrTitle, DrSubTitle  } from './styles';
import Company from '../Header/Company';
import { useIntl, FormattedMessage } from "gatsby-plugin-intl";

export const Footer = () => (
  <Wrapper>
    <Flex as={Container}>
      <Details>
        <FooterLogo>
          <Company />
        </FooterLogo>
        <FooterText>
          <span>
            © <FormattedMessage id="rights" /> {new Date().getFullYear()} <DrText> <DrTitle><FormattedMessage id="intro.dr.title" />,&nbsp;</DrTitle> <DrSubTitle><FormattedMessage id="intro.dr.subtitle" /></DrSubTitle></DrText>
            <br/><a href="https://www.google.com/maps/place/Sopron,+Kis+J%C3%A1nos+u.+3,+9400/@47.6817315,16.58541,17z/data=!3m1!4b1!4m6!3m5!1s0x476c3ca674a0240d:0x98d4e82a3782d734!8m2!3d47.6817279!4d16.5879849!16s%2Fg%2F11j8sk_70m?entry=ttu&g_ep=EgoyMDI2MDExMy4wIKXMDSoASAFQAw%3D%3D" title={useIntl().formatMessage({ id: "seo.title" })} target="blank">Sopron, Kis János u. 3.</a>
            <br/><Tel><a href="tel:+36706111427">+36 70 6111427</a></Tel>
            <br/><a href="/impressum" title="impressum">Impressum</a>
          </span>
        </FooterText>
      </Details>
    </Flex>
  </Wrapper>
);
